import { TFunction } from 'i18next';

import { SyncProgressItem } from '../syncProgressTypes';

export function syncProgressItemLabel(item: SyncProgressItem, t: TFunction): string {
  switch (item.type) {
    case 'operating_hours': {
      const intern = item.machineIntern?.trim();
      return intern ? t('itemOperatingHoursWithIntern', { intern }) : t('itemOperatingHours');
    }
    case 'periodic_check': {
      const intern = item.machineIntern?.trim();
      return intern ? t('itemPeriodicCheckWithIntern', { intern }) : t('itemPeriodicCheck');
    }
    case 'issue': {
      const intern = item.machineIntern?.trim();
      return intern ? t('itemIssueWithIntern', { intern }) : t('itemIssue');
    }
  }
}
